<template>
    <div ref="autocompleter" class="conflict-autocompleter" :class="[{open:open},orientationClass]">
        <div class="display" @click.stop="togglePopup">
            <span class="label">{{ choiceLabel }}</span>
            <span class="caret"><font-awesome-icon icon="caret-down"></font-awesome-icon></span>
        </div>
        <div class="popup" :class="{'show-autocompleter':showAutocompleter}" v-on-clickaway="closePopup">
            <div class="popup-inner">
                <div class="choices">
                    <ul>
                        <li v-for="choice in choices" @click="selectItem(choice)"><font-awesome-icon :icon="icon" v-if="icon" class="item-icon"></font-awesome-icon> {{ choice.label }}</li>
                        <!--<li v-for="choice in choices" @click="selectItem(choice)"><font-awesome-icon :icon="icon" v-if="icon" class="item-icon"></font-awesome-icon> {{ choice.label }}</li>
                        <li v-for="choice in choices" @click="selectItem(choice)"><font-awesome-icon :icon="icon" v-if="icon" class="item-icon"></font-awesome-icon> {{ choice.label }}</li>
                        <li v-for="choice in choices" @click="selectItem(choice)"><font-awesome-icon :icon="icon" v-if="icon" class="item-icon"></font-awesome-icon> {{ choice.label }}</li>
                        <li v-for="choice in choices" @click="selectItem(choice)"><font-awesome-icon :icon="icon" v-if="icon" class="item-icon"></font-awesome-icon> {{ choice.label }}</li>
                        <li v-for="choice in choices" @click="selectItem(choice)"><font-awesome-icon :icon="icon" v-if="icon" class="item-icon"></font-awesome-icon> {{ choice.label }}</li>
                        <li v-for="choice in choices" @click="selectItem(choice)"><font-awesome-icon :icon="icon" v-if="icon" class="item-icon"></font-awesome-icon> {{ choice.label }}</li>-->
                    </ul>
                    <div class="fixed-choice autocompleter-choice" v-if="autocompleter"
                         @click="toggleAutocompleter(true)">
                        <span>{{ labelSearch }}</span>
                        <span><font-awesome-icon icon="chevron-right"></font-awesome-icon></span>
                    </div>
                    <div class="fixed-choice creation-choice" v-if="creation" @click="choiceCreate">
                        <span>{{ labelAdd }}</span>
                        <span><font-awesome-icon icon="plus-circle"></font-awesome-icon></span>
                    </div>
                </div>
                <div class="autocompleter">
                    <div class="header">
                        <div class="back-btn" @click="toggleAutocompleter(false)">
                            <font-awesome-icon icon="chevron-left"></font-awesome-icon>
                        </div>
                        <div class="search-field">
                            <font-awesome-icon icon="search"></font-awesome-icon>
                            <input ref="searchField" type="text" v-model="autocompleterSearch" @keyup="search"/>
                        </div>
                    </div>
                    <div class="results">
                        <ul>
                            <li v-for="item in autocompleterResults" @click="selectItem(item)">
                                <font-awesome-icon :icon="icon" v-if="icon" class="item-icon"></font-awesome-icon> {{ item.label }}
                            </li>
                            <li v-for="item in autocompleterResults" @click="selectItem(item)">
                                <font-awesome-icon :icon="icon" v-if="icon" class="item-icon"></font-awesome-icon> {{ item.label }}
                            </li>
                            <li v-for="item in autocompleterResults" @click="selectItem(item)">
                                <font-awesome-icon :icon="icon" v-if="icon" class="item-icon"></font-awesome-icon> {{ item.label }}
                            </li>
                            <li v-for="item in autocompleterResults" @click="selectItem(item)">
                                <font-awesome-icon :icon="icon" v-if="icon" class="item-icon"></font-awesome-icon> {{ item.label }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'
    import {mapGetters,mapMutations} from 'vuex'

    import {mixin as clickaway} from 'vue-clickaway'

    import API from '@s/API'
    import axios from 'axios'
    import _debounce from 'lodash/debounce'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {
            ...mapGetters({
                currentPlugin: 'Plugins/current',
                currentStep: 'Plugins/currentStep'
            }),
            choiceLabel(){
                if(this.selectedItem){
                    return this.selectedItem.label
                }
                return 'Aucune sélection'
            },

        },
        created: function () {

        },
        data() {
            return {
                open: false,
                firstTime: true,
                showAutocompleter: false,
                selectedItem: null,
                autocompleterSearch: "",
                autocompleterResults: [],
                orientationClass: "down"
            }
        },
        destroyed: function () {

        },
        mixins: [clickaway],
        methods: {
            ...mapMutations({
                showLoading: 'UI/showLoading',
            }),
            togglePopup: function () {

                function offset(elt) {
                    var rect = elt.getBoundingClientRect(), bodyElt = document.body;
                    return {
                        top: rect.top + bodyElt .scrollTop,
                        left: rect.left + bodyElt .scrollLeft
                    }
                }
                var offsetElt = offset(this.$refs.autocompleter);

                //console.log(offsetElt.top,window.innerHeight)

                if(offsetElt.top > window.innerHeight / 2){
                    this.orientationClass = "up"
                }
                else{
                    this.orientationClass = "down"
                }

                this.open = !this.open;
                if (this.open && this.firstTime) {
                    this.firstTime = false;
                }
            },
            closePopup: function () {
                this.toggleAutocompleter(false)
                if (this.open && !this.firstTime) {
                    this.open = false;
                    this.firstTime = true;
                }
                else {
                    this.firstTime = false;
                }
            },

            toggleAutocompleter(val) {
                this.showAutocompleter = val
                if(val === true){
                    setTimeout(() => {
                        this.$refs.searchField.focus()
                    },300)

                }
                else{
                    this.clearSearch()
                }
            },

            selectItem(item){
                this.selectedItem = item
                this.toggleAutocompleter(false)
                this.closePopup(false)
                this.$emit('input',item.id)
            },

            clearSearch(){
                this.autocompleterSearch = ""
                this.autocompleterResults = []
            },

            choiceCreate(){
                this.selectItem({
                    id: 'new',
                    label: "Nouveau collaborateur"
                })
            },

            search: _debounce(function() {
                axios.get(API.route(this.autocompleterURL,{idConfiguration:this.currentPlugin.configurationId})+"?q="+this.autocompleterSearch)
                    .then(response => {
                        this.autocompleterResults = response.data
                        //this.showLoading(false)
                    })
            }, 500)
        },
        mounted: function () {




        },
        name: '',
        props: {
            choices: {
                type: Array,
                default: []
            },
            autocompleter: {
                type: Boolean,
                default: false
            },
            autocompleterURL: {
                type: String,
                default: ""
            },
            creation: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String,
                default: null
            },
            labelAdd: {
                type: String,
                default: "Nouveau"
            },
            labelSearch: {
                type: String,
                default: "Autre"
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .conflict-autocompleter {

        $comp-max-height: 200px;

        position: relative;
        width: 300px;
        margin-bottom: 10px;
        
        .item-icon{
            color: $main-color;
            opacity: 0.7;
            font-size: 0.8rem;
            vertical-align: middle;
            margin-right: 5px;
        }
        
        .display {
            border: solid $form-elements-border-size $main-color;
            border-radius: var(--input-radius);
            height: $form-elements-line-height;
            line-height: $form-elements-line-height;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            cursor: pointer;

            .label {
                flex: 1 1 100%;
                padding: 0 10px;
            }
            .caret {
                flex: 0 0 $form-elements-line-height;
                text-align: center;
            }
        }
        .popup {
            border: solid $form-elements-border-size $main-color;
            background-color: $main-white;
            position: absolute;
            box-shadow: 0 0 6px rgba(0, 0, 0, 0.16);
            width: 100%;
            transform-origin: top right;
            transform: scale(0, 0);
            opacity: 0;
            transition-property: transform, opacity;
            z-index: 10;
            overflow: hidden;
            top: $form-elements-line-height + 5px;


            .popup-inner{
                width: 200%;
                display: flex;
                flex-wrap: nowrap;
                flex-direction: row;
                transition-property: transform;
                height: 100%;


                .choices {

                    flex: 0 0 50%;
                    height: 100%;
                    //max-height: 100px;


                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                        border-bottom: solid 1px $main-color;
                        max-height: calc(#{$comp-max-height} - (2 * #{$form-elements-line-height}));
                        overflow: auto;


                        li {
                            height: $form-elements-line-height;
                            line-height: $form-elements-line-height;
                            padding: 0 10px;
                            cursor: pointer;
                        }
                    }
                    .fixed-choice {
                        display: flex;
                        flex-wrap: nowrap;
                        height: $form-elements-line-height;
                        line-height: $form-elements-line-height;
                        border-bottom: solid 1px $main-color;
                        padding: 0 0 0 10px;
                        cursor: pointer;

                        span:first-child {
                            flex: 1 1 100%;
                        }

                        span:last-child {
                            flex: 0 0 $form-elements-line-height;
                            text-align: center;
                        }

                        &.autocompleter-choice {

                        }
                        &.creation-choice {

                        }

                        &:last-child{
                            border-bottom: 0;
                        }
                    }
                }
                .autocompleter {
                    flex: 0 0 50%;

                    .header{
                        display: flex;
                        flex-wrap: nowrap;
                        border-bottom: solid $form-elements-border-size $main-color;

                        .back-btn{
                            flex: 0 0 $form-elements-line-height;
                            line-height: $form-elements-line-height;
                            text-align: center;
                            border-right: solid $form-elements-border-size $main-color;
                            cursor: pointer;
                        }

                        .search-field{
                            flex: 1 1 100%;
                            line-height: $form-elements-line-height;
                            position: relative;

                            input{
                                border: none;
                                flex: 1 1 100%;
                                line-height: $form-elements-line-height;
                                padding: 0 0 0 $form-elements-line-height;
                                width: 100%;
                            }

                            .svg-inline--fa{
                                flex: 0 0 $form-elements-line-height;
                                line-height: $form-elements-line-height;
                                position: absolute;
                                top: 50%;
                                left: 10px;
                                transform: translate(0,-50%);
                                opacity: 0.5;
                            }

                        }
                    }

                    .results{


                        ul{
                            list-style: none;
                            padding: 0;
                            margin: 0;
                            max-height: calc(#{$comp-max-height} - (#{$form-elements-line-height + $form-elements-border-size}));
                            overflow: auto;

                            li{
                                height: $form-elements-line-height;
                                line-height: $form-elements-line-height;
                                padding: 0 10px;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }



            &.show-autocompleter {
                .popup-inner{
                    transform: translate(-50%,0);
                }
            }


        }

        &.up{
            .popup {
                transform-origin: bottom right;
                top: auto;
                bottom: ($form-elements-line-height) + 5px;
            }
        }

        &.open {
            .popup {
                transform: scale(1, 1);
                opacity: 1;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/plugins/formbuilder/ConflictAutocompleter.vue